import { TCampaignTileAemPayload } from '../schema/campaign-tile/CampaignTileData';
import { TPersonalizedVehicle, TranslationData } from '../schema/t4-personalization/PersonalizationData';
import { ProductDto } from '../types/dls/dls-response/ProductDto';
import { OptionalResponseTypes } from '../types/GeneralTypes';
import type { Vehicle } from '../types/one-search/queries';
import { RawDataSchema } from '../types/raw/RequestParams';

export type PersonalizedVehicle = Partial<ProductDto> & TranslationData;

export async function getRawData(rawData: { schema: RawDataSchema; data: unknown }): Promise<OptionalResponseTypes> {
  if (rawData.schema === RawDataSchema.DLS) {
    return {
      ...(rawData.data as Partial<ProductDto>),
      responseTypeId: 'ProductDto',
    };
  }

  if (rawData.schema === RawDataSchema.ONE_SEARCH) {
    return {
      search: {
        results: [rawData.data as Partial<Vehicle>],
      },
      responseTypeId: 'OneSearchGraphQlWithRawData',
    };
  }

  if (rawData.schema === RawDataSchema.CAMPAIGN_TILE) {
    const rawT4Data = rawData.data as unknown as TCampaignTileAemPayload;
    return {
      rawData: rawT4Data,
      responseTypeId: 'CampaignTileVehicleDto',
    };
  }

  if (rawData.schema === RawDataSchema.T4_PERSONALIZATION) {
    const rawT4Data = rawData.data as unknown as TPersonalizedVehicle;
    return {
      personalizedVehicle: rawT4Data,
      responseTypeId: 'T4VehicleDto',
    };
  }
  throw new Error(`This RawData Schema ${rawData.schema} is not available`);
}
